import { render, staticRenderFns } from "./BonusSearch.vue?vue&type=template&id=f2704e72&scoped=true"
import script from "./BonusSearch.vue?vue&type=script&lang=js"
export * from "./BonusSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2704e72",
  null
  
)

export default component.exports